module.exports = __webpack_public_path__ + "static/img/AI_target.db2f136a.jpg";